import { ErrorResponse, GlobalResponseObject, OperationTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { OperationSequenceDto, OperationSequenceResponse, OperationSequenceResponseModel, ValAddOperationsModel, ValAddOpModel, variantOperationResponseModel, VarientIdRequest, VarientOperationsDTO } from '@gtpl/shared-models/production-management';
import { saleOrderItemIdRequest } from '@gtpl/shared-models/sale-management';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { SequenceDataModel } from 'libs/shared-models/production-management/src/lib/varient-operations/sequence-data.model';
import { Repository } from 'typeorm';
import { OperationSequenceRequest } from '../operations-track/dto/operation-sequence.request';
import { SequenceModel } from './dto/sequence-model';
import { VariantNextOpModel } from './dto/variant-next-op.model';
import { VarientOperationDTO } from './dto/variant-operation.dto';
import { VariantOperationAdapter } from './dto/varient-operation.adapter';
import { VariantOperationRepository } from './repository/variant-operation.repository';
import { VariantOperation } from './variant-operation.entity';

@Injectable()
export class VariantOperationsService {

    constructor(
        private variantOpRepository: VariantOperationRepository,
        private varientOperationAdapter: VariantOperationAdapter,
        private saleOrderService: SaleOrderService,
      ) { }

    async createVarientOperation(operationSeqDto:VarientOperationDTO,isUpdate:boolean=false): Promise<variantOperationResponseModel> {
        try {
          if (!isUpdate) {
            const variantOperationEntity = await this.getDuplicateVariantOperation(operationSeqDto.variantId);
          if (variantOperationEntity.length > 0) {
            throw new ErrorResponse(11104, 'Operation Sequence already exists for the variant');
          }
        }
          let savedProductDto:VarientOperationDTO[] = []
          let savedFlagSet = new Set<boolean>()
        for(const record of operationSeqDto.sequenceData){
          const productEntity = this.varientOperationAdapter.convertDtoToEntity(operationSeqDto.variantId,operationSeqDto.variantCode,record,isUpdate);
          const savedProductEntity = await this.variantOpRepository.save(productEntity);
          if(savedProductEntity){
            savedFlagSet.add(true);
          }else{
            savedFlagSet.add(false);
          }
          // const savedProduct: VarientOperationDTO = this.varientOperationAdapter.convertEntityToDto(savedProductEntity);
          // savedProductDto.push(savedProduct)
        }
        
         if (!savedFlagSet.has(false)) {
          const response = new variantOperationResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Operation Sequence For varient Updated Successfully':'Operation Sequence For varient Created Successfully',savedProductDto);
          return response;
        } else {
          throw new ErrorResponse(11106,'Product saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        throw error;
      }

      
    }

    async getDuplicateVariantOperation(variantId: number): Promise<VariantOperation[]> {
          const response = await this.variantOpRepository.find({
          where: {variantId: variantId},
          });
          if (response) {
          return response;
          } else {
          return null;
          }
      }

      async getOperationSequence(inputReq:OperationSequenceRequest):Promise<OperationSequenceResponse>{
        let prevOpName;
        let nextOpName;
        let response
        let varientId;
        const soData = await this.saleOrderService.getVarientInfoForSoItem(new saleOrderItemIdRequest(inputReq.saleOrderItemId))
        if(soData.status){
          varientId = soData.data.variantId;//need to wtite in so
          const opSequenceData = await this.variantOpRepository.findOne({select:['operationId','sequence'],where:{operationName:inputReq.presentOperation,variantId:varientId}})
          if(opSequenceData){


            const presentSequence = opSequenceData.sequence;
            const previousSequence = opSequenceData.sequence-1;
            const nextSequence = opSequenceData.sequence+1;
            let previousOpSequenceData = await this.variantOpRepository.findOne({select:['operationName'],where:{sequence:previousSequence,variantId:varientId}});
            if(previousOpSequenceData){
              prevOpName = previousOpSequenceData.operationName;
            }else{
              prevOpName = 'No Previous Operation';
            }

            let nextOpSequenceData = await this.variantOpRepository.findOne({select:['operationName'],where:{sequence:nextSequence,variantId:varientId}});

            if(nextOpSequenceData){
              nextOpName = nextOpSequenceData.operationName;
            }else{
              nextOpName = OperationTypeEnum.NO_OPERATION;
            }
            const data = new OperationSequenceDto(opSequenceData.operationId,prevOpName,nextOpName)
            response = new OperationSequenceResponse(true,5555,'Operation Sequence retreived',data)
          }else{
            response = new OperationSequenceResponse(false,9999,'No data found',null)
          }
        }else{
          response = new OperationSequenceResponse(false,9999,'No VarientData found',null)
        }
        return response;

      }



      //get next operation for variant id
      async getNextOperationForVariantId(inputReq:VariantNextOpModel):Promise<OperationTypeEnum> {
        const opSequenceData = await this.variantOpRepository.findOne({select:['operationId','sequence'],where:{operationName:inputReq.presentOperation,variantId:inputReq.variantId}})
        if(!opSequenceData){
          throw new ErrorResponse(10000,'Failed to get next operation');
        }
        const nextOpSequenceData = await this.variantOpRepository.findOne({select:['operationName'],where:{sequence:opSequenceData.sequence+1,variantId:inputReq.variantId}});
        if(!nextOpSequenceData){ 
          throw new ErrorResponse(10000,'Failed to get next operation');
        }
        return <OperationTypeEnum>nextOpSequenceData.operationName;
      }

      

      //get val addition operations
      async getValAddOperations(unitReq:UnitRequest):Promise<ValAddOperationsModel> {
        console.log(unitReq);
        
        const opSequenceData = await this.variantOpRepository.createQueryBuilder('VariantOperation')
        .select('distinct(operation_name) as operationName')
        .where(`category='${OperationTypeEnum.VALUE_ADDITION}'`)
        .getRawMany();
        console.log('opSequenceData');
        console.log(opSequenceData);
        if(!opSequenceData){
          return new ValAddOperationsModel(false,10000,'Failed to get data',undefined);
        }else{
          const valaddOperations:ValAddOpModel[] = [];
          for(const valAddOperation of opSequenceData){
            const valAddOpObj = new ValAddOpModel(valAddOperation.sequence,valAddOperation.operationId,valAddOperation.operationName,valAddOperation.VarientOperationId,valAddOperation.unitId);
            valaddOperations.push(valAddOpObj);
          }
          return new ValAddOperationsModel(true,9999,'Data retrived',valaddOperations);
        }
        
        
      }

       //get prev operation for variant id
       async getPrevOperationForVariantId(inputReq:VariantNextOpModel):Promise<OperationTypeEnum> {
        const opSequenceData = await this.variantOpRepository.findOne({select:['operationId','sequence'],where:{operationName:inputReq.presentOperation,variantId:inputReq.variantId,unitId:inputReq.plantId}})
        if(!opSequenceData){
          throw new ErrorResponse(10000,'Failed to get prev operation');
        }
        const nextOpSequenceData = await this.variantOpRepository.findOne({select:['operationName'],where:{sequence:opSequenceData.sequence-1,variantId:inputReq.variantId,unitId:inputReq.plantId}});
        if(!nextOpSequenceData){ 
          throw new ErrorResponse(10000,'Failed to get prev operation');
        }
        return <OperationTypeEnum>nextOpSequenceData.operationName;
      }

      async getOperationsAssignedByVarientId(inputReq:VarientIdRequest):Promise<any> {
        
        const sequenceDataModel : SequenceDataModel[] = [];
        const opSequenceData = await this.variantOpRepository.find({where:{variantId:inputReq.variantId},order:{sequence:'ASC'}});
        if(opSequenceData){
          return opSequenceData
        }else{
          return [];
        }
        // console.log(opSequenceData.length);
        // return opSequenceData;
        // if(opSequenceData.length>0){
        //   for(const record of opSequenceData){
        //     const data = new SequenceDataModel(record.sequence,record.operationId,record.operationName,record.operationGroup,record.groupDependency,record.operationDependency,record.lossOrGainPercentage,record.isActive,record.createdAt,record.createdUser,record.unitId,record.updatedUser,record.versionFlag,record.VarientOperationId);
        //     sequenceDataModel.push(data);
        //   }
        //   return new OperationSequenceResponseModel(true, 1001, 'Operation Sequences retrived successfully. ', sequenceDataModel);
        // }
        // else{
        //   return new OperationSequenceResponseModel(false, 1001, 'Operation Sequences not found. ', sequenceDataModel);
        // }
       
      }
}
